<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div>
          <label class="label-input">Section Title</label>
          <v-text-field v-model="fields.title" label="Title" />
        </div>

        <div class="mt-6">
          <label class="label-input">Section Settings</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <ColorPicker
                  v-model="fields['background-color']"
                  name="background-color"
                  label="Background Color"
                  default-color="#ffffff"
                />
              </v-col>
              <v-col cols="12" md="6">
                <ColorPicker
                  v-model="fields['text-color']"
                  name="text-color"
                  label="Text Color"
                  default-color="#000000"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox class="mt-0" v-model="fields.topPadding" label="Top padding" hide-details />
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox class="mt-0" v-model="fields.bottomPadding" label="Bottom padding" hide-details />
              </v-col>
              <v-col cols="12" md="12">
                <div class="mb-3">
                  <v-switch v-model="fields.enableContainerPage" label="Enable container page" hide-details />
                </div>
                <div v-show="fields.enableContainerPage">
                  <ColorPicker
                    v-model="fields.backgroundContainer"
                    name="background-container"
                    label="Background Container"
                    default-color="#ffffff"
                  />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mt-6">
          <div class="label-input">Item Slider Settings</div>
          <div class="group-item">
            <v-row>
              <v-col cols="12">
                <div class="">
                  <ColorPicker
                    v-model="fields.settingItem.mainColorItem"
                    name="mainColorItem"
                    label="Main Color Item"
                    default-color="#cb6387"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <v-checkbox
                  v-model="fields.settingItem.enableBackgroundItem"
                  label="Enable background item"
                  hide-details
                  class="mt-0 pt-0 mb-2"
                />
                <div v-show="fields.settingItem.enableBackgroundItem">
                  <GradientColorPicker
                    :startColor="fields.settingItem.bgStart"
                    :endColor="fields.settingItem.bgEnd"
                    @update:startColor="fields.settingItem.bgStart = $event"
                    @update:endColor="fields.settingItem.bgEnd = $event"
                  />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mt-6">
          <label class="label-input">Title Card</label>
          <div class="group-item">
            <div class="mb-3">
              <v-checkbox v-model="fields['show-title']" label="Show title" hide-details class="mt-0 pt-0" />
            </div>
            <ckeditor :editor="editor" v-model="fields['title-card']" :config="editorConfig" />
          </div>
        </div>

        <div class="mt-6">
          <div class="d-flex justify-space-between align-center">
            <label class="label-input mb-0">Reviews</label>
            <v-btn small text color="primary" @click="handleAddItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add review</span>
            </v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(item, index) in fields.listItem" :key="index">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center" style="width: 100%">
                  <span>Review {{ index + 1 }}</span>
                  <v-btn icon @click.stop="handleRemoveItem(index)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <UploadImage
                  @callback="obj => handleUploadAvatar(obj, index)"
                  :image="{ imageSrc: item.avatar }"
                  :height="`100`"
                  :typeUpload="'image'"
                  @callbackDelete="() => handleRemoveAvatar(index)"
                />
                <v-text-field v-model="item.nameReviewer" label="Reviewer Name" class="mt-3" />
                <!-- <v-text-field
                  v-model.number="item.starsReview"
                  type="number"
                  min="1"
                  max="5"
                  label="Stars (1-5)"
                  class="mt-3"
                /> -->
                <v-rating
                  color="warning"
                  background-color="#c1c1c1"
                  empty-icon="mdi-star-outline"
                  full-icon="mdi-star"
                  hover
                  length="5"
                  size="28"
                  v-model="item.starsReview"
                />
                <div class="mt-3">
                  <label>Review content</label>
                  <ckeditor :editor="editor" v-model="item.contentReview" :config="editorConfig" />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';

import Editor from 'ckeditor5-custom-build/build/ckeditor';
import ColorPicker from './common/color-picker.vue';
import GradientColorPicker from './common/gradient-color-picker.vue';

const DEFAULT_AVATAR = 'https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0de60790e7b4d92dbc878.webp?w=200';

export default {
  name: 'policy-yuri-reivew-section-editor',
  components: {
    ColorPicker,
    UploadImage,
    GradientColorPicker,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Policy Yuri Reivew Section',
        'title-card': '<h2>Reviews</h2><p>Experience the transformative power</p>',
        'show-title': true,
        'background-color': '#ffffff',
        'text-color': '#000000',
        enableContainerPage: true,
        topPadding: true,
        bottomPadding: true,
        settingItem: {
          enableBackgroundItem: true,
          bgStart: '#fff5f9',
          bgEnd: '#ffffff',
          mainColorItem: '#cb6387',
        },
        listItem: [],
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
      listItem: Array.isArray(this.sectionEditor.sectionExtract?.listItem)
        ? this.sectionEditor.sectionExtract.listItem
        : this.fields.listItem,
    };
  },
  methods: {
    handleUploadAvatar(obj, index) {
      this.fields.listItem[index].avatar = obj.imageSrc;
    },
    handleRemoveAvatar(index) {
      this.fields.listItem[index].avatar = '';
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleAddItem() {
      this.fields.listItem.push({
        avatar: DEFAULT_AVATAR,
        nameReviewer: 'John Doe',
        starsReview: 5,
        contentReview: '<p>Great product. My skin feels smoother overnight.</p>',
      });
    },
    handleRemoveItem(index) {
      this.fields.listItem.splice(index, 1);
    },
    handleSave() {
      const payload = {
        ...this.fields,
        listItem: (this.fields.listItem || []).map(item => ({
          avatar: item.avatar || '',
          nameReviewer: item.nameReviewer || '',
          starsReview: Math.min(Math.max(parseInt(item.starsReview, 10) || 5, 1), 5),
          contentReview: item.contentReview || '',
        })),
      };
      const updateHtml = updateHtmlFromData.sectionPolicyYuriReivew(this.sectionEditor.section.html, payload);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.ck-editor__editable_inline {
  min-height: 220px;
}
.ck-editor__editable {
  min-height: 220px;
}
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
